import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';


@Injectable()
export class DashboardService {
  private _url = 'api/dashboard';

  constructor(private _httpClient: HttpClient) { }

  async getEntityTotalChart(groupid?: string): Promise<[]> {
    return new Promise((resolve, reject) => {

      const params = new HttpParams()
      .set('groupid', groupid || 'all')

      this._httpClient.get<[]>(`${this._url}/entity-total-chart`, { params }).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async getSurveyTotalChart(groupid?: string): Promise<[]> {
    return new Promise((resolve, reject) => {

      const params = new HttpParams()
      .set('groupid', groupid || 'all')

      this._httpClient.get<[]>(`${this._url}/survey-total-chart`, { params }).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }

  async getSurveyGroupChart(): Promise<[]> {
    return new Promise((resolve, reject) => {
      this._httpClient.get<[]>(`${this._url}/survey-group-chart`).subscribe({
        next(value) {
          resolve(value);
        },
        error(err) {
          reject(err)
        }
      });
    });
  }
}
